import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';
import _ from 'lodash';

export function* getTournaments() {
    yield* takeEvery("TOURNAMENTS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/tournaments${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { tournaments, tournament, seasonTypes } = result;
                if (action.id) {
                    yield put({ type: 'TOURNAMENT/SET', tournament });
                } else {
                    yield put({ type: 'TOURNAMENTS/SET', tournaments });
                }
                yield put({ type: 'SEASON_TYPES/SET', seasonTypes });
            } else {
                yield put({ type: 'TOURNAMENTS/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'TOURNAMENTS/FETCH_FAILED', e });
        }
    });
}

export function* getTournamentSeasons() {
    yield* takeEvery("TOURNAMENT_SEASONS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/tournaments/tournament_seasons`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);
            if (result && result.success) {
                const { tournament_seasons } = result;
                yield put({ type: 'TOURNAMENT_SEASONS/SET', tournament_seasons });
            } else {
                yield put({ type: 'TOURNAMENT_SEASONS/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'TOURNAMENT_SEASONS/FETCH_FAILED', e });
        }
    });
}

export function* getUpcomingTournaments() {
    yield* takeEvery("TOURNAMENTS/FETCH/UPCOMING", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/tournaments/upcoming`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { tournaments } = result;
                localStorage.setItem('CS.UPCOMING', JSON.stringify(tournaments));
                yield put({ type: 'UPCOMING/SET', upcoming: tournaments });
            } else {
                yield put({ type: 'UPCOMING/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'UPCOMING/FETCH_FAILED', e });
        }
    });
}

//TOURNAMENTS/FETCH/UPCOMING/ALL
export function* getUpcomingTournamentsAll() {
    yield* takeEvery("TOURNAMENTS/FETCH/UPCOMING/ALL", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/tournaments/upcoming/all`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { tournaments } = result;
                localStorage.setItem('CS.UPCOMING', JSON.stringify(_.take(tournaments, 3)));
                yield put({ type: 'UPCOMING/SET', upcoming: tournaments });
            } else {
                yield put({ type: 'UPCOMING/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'UPCOMING/FETCH_FAILED', e });
        }
    });
}

export function* getPastTournaments() {
    yield* takeEvery("TOURNAMENTS/FETCH/PAST", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/tournaments/past`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { tournaments } = result;
                yield put({ type: 'PAST/SET', past: tournaments });
            } else {
                yield put({ type: 'PAST/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'PAST/FETCH_FAILED', e });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/tournaments.js